interface Properties {
  width?: any;
  height?: any;
  color?: string;
  marginRight?: string;
}
const AddPageIcon = ({ width, height, color, marginRight }: Properties) => {
  return (
    <svg
      style={{ marginRight }}
      width={width || '15'}
      height={height || '15'}
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.20817 3.95866H6.7915V6.79199H3.95817V8.20866H6.7915V11.042H8.20817V8.20866H11.0415V6.79199H8.20817V3.95866ZM7.49984 0.416992C3.58984 0.416992 0.416504 3.59033 0.416504 7.50033C0.416504 11.4103 3.58984 14.5837 7.49984 14.5837C11.4098 14.5837 14.5832 11.4103 14.5832 7.50033C14.5832 3.59033 11.4098 0.416992 7.49984 0.416992ZM7.49984 13.167C4.37609 13.167 1.83317 10.6241 1.83317 7.50033C1.83317 4.37658 4.37609 1.83366 7.49984 1.83366C10.6236 1.83366 13.1665 4.37658 13.1665 7.50033C13.1665 10.6241 10.6236 13.167 7.49984 13.167Z'
        fill={color || '#787878'}
      />
    </svg>
  );
};

export default AddPageIcon;
